import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  progress: {
    position: 'absolute',
    top: -3,
    left: -3,
    zIndex: 1
  }
})
export default withStyles(styles, { withTheme: true })(
  class UserSelectionComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      theme: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
      color: PropTypes.string,
      disabled: PropTypes.bool,
      onSelect: PropTypes.func.isRequired
    }
    static defaultProps = {}
    state = {
      loading: false
    }
    handleSelectUser = e => {
      this.setState({ loading: true })
      this.props.onSelect(this.props.user)
    }
    render() {
      const { classes, user, color, theme, disabled } = this.props
      let initials = (
        user.user_first_name[0] + user.user_last_name[0]
      ).toUpperCase()
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          container
          direction="column"
          alignItems="center"
          justify="center"
          spacing={16}>
          <Grid item>
            <Button
              disabled={this.state.loading || disabled}
              style={{ backgroundColor: color || theme.palette.primary.main }}
              onClick={this.handleSelectUser}
              color="primary"
              variant="fab">
              {initials}
              {this.state.loading && (
                <CircularProgress
                  style={{ color: '#fff' }}
                  size={62}
                  thickness={3}
                  className={classes.progress}
                />
              )}
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="subheading" noWrap>
              {`${user.user_first_name} ${user.user_last_name}`}
            </Typography>
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/hbUsers/UserComponent.js